module.exports = "<code ng-repeat=\"parte in $ctrl.partes track by $index\">\r\n  <cspan class=\"{{n === '' ? 'text-light' : ''}}\" ng-repeat=\"n in parte track by $index\">{{::n === '' ? 0 : n}}</cspan>\r\n  <span class=\"text-light\" ng-if=\"!$last\">-</span></code>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/contabilidad/polizas/components/cuentacontable/template.html
// module id = 1792
// module chunks = 0